import { EligibilityPatientDemographicInformation } from "./EligibilityPatientDemographicInformation";
import { HealthInsuranceEligibilityStatus } from "./HealthInsuranceEligibilityStatus";

class HealthInsuranceEligibility {
    public Eligibility: HealthInsuranceEligibilityStatus = HealthInsuranceEligibilityStatus.Unknown;
    public FetchDate?: Date;
    public EligibilityExpiryDate?: Date;
    public EligibilityMessage?: string;
    public PatientRestriction?: string;
    public PatientDemographicInformation?: EligibilityPatientDemographicInformation;

    public constructor(fields?: Partial<HealthInsuranceEligibility>) {
        Object.assign(this, fields);
    }
}

export { HealthInsuranceEligibility };
